import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";
import { EdpToastType } from "@edp-components/edp-toaster/edp-toast-type";
import { EdpToasterService } from "@edp-components/edp-toaster/edp-toaster.service";
import { StepsService } from "@edp-pages/requests-and-operations/services/steps.service";
import { NgbDateStruct, NgbDate } from "@ng-bootstrap/ng-bootstrap";
import { TranslateService } from "@ngx-translate/core";
import moment from "moment";
import { select, Store } from "@ngrx/store";
import { IAppState } from "@edp-store/state/app.state";
import { GetAvailableTimeSlots } from "@edp-store/actions/requests-and-operations.actions";
import { getRequestsAndOperationsTimeSlots } from "@edp-store/selectors/requests-and-operations.selector";
import { IInterventionDate, ITimeSlot } from "@edp-models/requests-and-operations";
import { filter, takeUntil } from "rxjs/operators";
import { Observable, Subject } from "rxjs";
import { showLoader } from "@edp-store/selectors/layout.selectors";
import { CookieService } from "ngx-cookie-service";
import { LanguageTypeEnum } from "@edp-enums/language.enum";
import { LanguageService } from "@edp-services/language.service";
@Component({
    selector: "create-request-datepicker",
    templateUrl: "./create-request-datepicker.component.html",
    styleUrls: ["./create-request-datepicker.component.scss"],
})
export class CreateRequestDatepickerComponent implements OnInit, OnDestroy {
    @Input() selectedSlot: ITimeSlot;
    @Output() selectedSlotChange: EventEmitter<ITimeSlot> = new EventEmitter<ITimeSlot>();

    public date: { year: number; month: number };
    public availableDates: IInterventionDate[] = [];
    public enabledDates: string[] = [];
    private _model: NgbDate;
    public slots: ITimeSlot[] = [];
    public calendarDataLoaded: Observable<boolean> = this.store.select(showLoader);

    private unsubscribe$ = new Subject();

    constructor(
        private readonly stepService: StepsService,
        private readonly toaster: EdpToasterService,
        private readonly translate: TranslateService,
        private store: Store<IAppState>,
        public languageService: LanguageService
    ) {}

    ngOnInit() {
        this.store.dispatch(new GetAvailableTimeSlots());
        this.store.pipe(
            select(getRequestsAndOperationsTimeSlots),
            takeUntil(this.unsubscribe$),
            filter(dates => Array.isArray(dates))
        ).subscribe(dates => {
            this.availableDates = dates;
            this.enabledDates = this.availableDates.map(dateObj => dateObj.date);
            this.checkEmptySlots();
            this.stepService.setAdvanceStepButtonAvailability(false);
        });
    }

    set model(val) {
        this._model = val;
        this.checkSelectedDate();
    }

    get model() {
        return this._model;
    }


    private checkSelectedDate() {
        const selectedDate = moment(`${this.model.day}-${this.model.month}-${this.model.year}`, "DD-MMM-YYYY")
            .locale(this.languageService.getLocale())
            .format("DD-MMM-YYYY");
        const availableDate = this.availableDates.find(
            availableDate =>
                moment(availableDate.date, "DD-MMM-YYYY")
                    .locale(this.languageService.getLocale())
                    .format("DD-MMM-YYYY") === selectedDate
        );
        this.slots = availableDate ? availableDate.timeSlots : [];
        this.selectSlot(null);
    }

    public selectSlot(slot: ITimeSlot | null): void {
        this.selectedSlot = slot;
        this.selectedSlotChange.emit(slot);
        this.stepService.setAdvanceStepButtonAvailability(slot !== null);
    }

    isDisabled = (date: NgbDateStruct) => {
        const compareDate =
            date.day.toString().padStart(2, "0") + "-" + date.month.toString().padStart(2, "0") + "-" + date.year.toString();
        return !this.enabledDates.includes(compareDate);
    }

    private checkEmptySlots(): void {
        if (!this.enabledDates.length) {
            this.toaster
                .create(
                    this.translate.instant("pt.edp.edponline.resquests-and-operations.creation.scheduling.no-slots"),
                    EdpToastType.error
                )
                .show();
        }
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}
